<template>
    <form v-if="!loading" @submit.prevent="departmentUUID ? requestUpdate() : requestCreate()">
        <b-form-group :label="$t('module.department')" label-cols="4" label-align="left">
            <multiselect
                v-model="createForm.department"
                track-by="value"
                label="text"
                :placeholder="$t('message.pleaseSelectX', [$t('module.department')])"
                :options="departmentDdl"
                :searchable="true"
                :allow-empty="false"
                :class="{ 'border border-danger': submitted && !$v.createForm.department.required }"
            />
            <div v-if="submitted && !$v.createForm.department.required" class="invalid-feedback d-block text-right">
                {{ $t('message.requiredX', [$t('module.department')]) }}
            </div>
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button type="button" variant="danger" class="mr-2 col-3" :disabled="!status.save" @click="$emit('done')">
                {{ $t('label.cancel') }}
            </b-button>
            <b-button type="submit" variant="info" class="col-3" :disabled="!status.save || !loaded">
                <span v-if="status.save">{{ departmentUUID ? $t('label.updateX', []) : $t('label.createX', []) }}</span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status" />
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { phoneExtDepartmentMethods, lookupMethods } from "@/state/api";
import { PHONE_EXT_DEPARTMENT_MODULE } from "@/state/api/phoneExtDepartment.state";

export default {
    components: { Multiselect },
    props: {
        groupUUID: { type: String, required: true },
        departmentUUID: { type: String, default: '' },
        sequence: { type: Number, default: 1 },
    },
    validations() {
        return { createForm: { department: { required } } };
    },
    async created() {
        await this.lookupDepartment({});
        await this.getDepartmentData();
    },
    data() {
        return {
            submitted: false,
            loading: false,
            loaded: !this.departmentUUID,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...phoneExtDepartmentMethods,
        ...lookupMethods,
        defaultForm() {
            return { uuid: '', department: null, sequence: this.sequence };
        },
        async getDepartmentData() {
            if (this.departmentUUID) {
                this.loading = true;
                await this.getPhoneExtDepartment({uuid: this.departmentUUID})
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                department: this.data.department ? {
                                    value: this.data.department.uuid,
                                    text: this.data.department.name,
                                } : null,
                                sequence: this.data.sequence,
                            };
                            this.loaded = true;
                        }
                    });
                this.loading = false;
            }
        },
        requestCreate() {
            if (!this.status.save || !this.loaded) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            let data = {
                uuid: this.createForm.uuid,
                departmentUuid: this.createForm.department.value,
                sequence: this.createForm.sequence,
                phoneExtGroupUuid: this.groupUUID,
            };
            this.createPhoneExtDepartment({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.$emit('reload');
                        this.$emit('done');
                    }
                }));
        },
        requestUpdate() {
            if (!this.status.save || !this.loaded) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            let data = {
                uuid: this.createForm.uuid,
                departmentUuid: this.createForm.department.value,
                sequence: this.createForm.sequence,
                phoneExtGroupUuid: this.groupUUID,
            };
            this.updatePhoneExtDepartment({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.$emit('reload');
                        this.$emit('done');
                    }
                }));
        },
    },
    computed: {
        departmentDdl() {
            return this.$store.state.api.lookup.departmentDdl || [];
        },
        ...mapState(PHONE_EXT_DEPARTMENT_MODULE, ['status']),
        data() {
            return this.$store.state.api.phoneExtDepartment.details;
        },
    },
};
</script>
